import { RSAA } from 'redux-api-middleware';
import { userAccountPropertiesSelector as propertiesSelector } from '../selectors/properties';
import { userAccountIsUnauthenticatedSelector as isUnauthenticatedSelector } from '../selectors/isUnauthenticated';
import { CHANGE_PASSWORD_WITH_TOKEN } from './types';

const paramsToHeaders = ({ token }) => ({
  Authorization: `Bearer ${token}`,
});

const paramsToBody = ({ currentPassword, password, confirmPassword }) => ({
  currentPassword,
  password,
  confirmPassword,
});

const requestApiAction = (params) => ({
  [RSAA]: {
    endpoint: '/v3/user/change-password',
    method: 'POST',
    credentials: 'include',
    headers: paramsToHeaders(params),
    body: paramsToBody(params),
    types: [
      CHANGE_PASSWORD_WITH_TOKEN.REQUEST,
      CHANGE_PASSWORD_WITH_TOKEN.SUCCESS,
      CHANGE_PASSWORD_WITH_TOKEN.FAILURE,
    ],
  },
});

export const userAccountChangePasswordStoredTokenThunkAction = (params) => (dispatch, getState) => {
  const state = getState();
  const isUnauthenticated = isUnauthenticatedSelector(state);
  const { accessToken } = propertiesSelector(state);
  const combinedParams = { ...params, ...{ token: accessToken } };

  if (!isUnauthenticated && accessToken) {
    return dispatch(requestApiAction(combinedParams));
  }

  return null;
};
